module.exports = __webpack_public_path__ + "assets/img/img-detail-bottom.24a301d5.jpg";